export const ImageProcessingEngineVersion = 36;
export const DoSmallDetailsPart = true;
